import { useRouter } from 'next/router';

import TrpContent from '@/components/trp/TrpContent';

// Tax Refund Payment
const TrpPage = () => {
  const router = useRouter();

  const token: string = (router?.query?.token ?? '') as string;

  // 토큰이 없으면 404로
  if (router.isReady && !token) {
    router.push({
      pathname: '/404',
      query: router.query
    });
  }

  return (
    <div className="w-full">
      <div className="flex flex-col mx-auto max-w-[1024px]">{token ? <TrpContent token={token} /> : <></>}</div>
    </div>
  );
};

export default TrpPage;
